module.exports = __webpack_public_path__ + "img/69f20d5.png";